enum PositionDirection {
    TO_BACK = "TO_BACK",
    TO_FRONT = "TO_FRONT",
}

export default PositionDirection;